module.exports = __webpack_public_path__ + "static/media/linnaeus.514692d8.jpg";